export default __webpack_public_path__ + "img/dpefBcpQ.802f487a.svg";